import { practiceService } from '@/services'
import Enumerable from 'linq/linq.js'

const flagMap = () => ([
    // Progress flags
    {
        flag: 'ActivitySet',
        message: 'Requires a system activity review be saved.',
        link: '/activity-list',
        order: 26
    }, {
        flag: 'BASet',
        message: 'Requires a business associate be saved.',
        link: '/ba-list',
        order: 5
    }, {
        flag: 'InventorySet',
        message: 'Requires ePHI inventory be saved.',
        link: '/inventory-list',
        order: 4
    }, {
        flag: 'JobRolesSet',
        message: 'Requires job roles be saved.',
        link: '/practice/roles',
        order: 2
    }, {
        flag: 'Policy001Set',
        message: 'Requires policy 1 approval.',
        link: '/policy-edit/001',
        order: 6
    }, {
        flag: 'Policy002Set',
        message: 'Requires policy 2 approval.',
        link: '/policy-edit/002',
        order: 7
    }, {
        flag: 'Policy003Set',
        message: 'Requires policy 3 approval.',
        link: '/policy-edit/003',
        order: 8
    }, {
        flag: 'Policy004Set',
        message: 'Requires policy 4 approval.',
        link: '/policy-edit/004',
        order: 9
    }, {
        flag: 'Policy005Set',
        message: 'Requires policy 5 approval.',
        link: '/policy-edit/005',
        order: 10
    }, {
        flag: 'Policy006Set',
        message: 'Requires policy 6 approval.',
        link: '/policy-edit/006',
        order: 11
    }, {
        flag: 'Policy007Set',
        message: 'Requires policy 7 approval.',
        link: '/policy-edit/007',
        order: 12
    }, {
        flag: 'Policy008Set',
        message: 'Requires policy 8 approval.',
        link: '/policy-edit/008',
        order: 13
    }, {
        flag: 'Policy009Set',
        message: 'Requires policy 9 approval.',
        link: '/policy-edit/009',
        order: 14
    }, {
        flag: 'Policy010Set',
        message: 'Requires policy 10 approval.',
        link: '/policy-edit/010',
        order: 15
    }, {
        flag: 'Policy011Set',
        message: 'Requires policy 11 approval.',
        link: '/policy-edit/011',
        order: 16
    }, {
        flag: 'Policy012Set',
        message: 'Requires policy 12 approval.',
        link: '/policy-edit/012',
        order: 17
    }, {
        flag: 'Policy013Set',
        message: 'Requires policy 13 approval.',
        link: '/policy-edit/013',
        order: 18
    }, {
        flag: 'Policy014Set',
        message: 'Requires policy 14 approval.',
        link: '/policy-edit/014',
        order: 19
    }, {
        flag: 'Policy015Set',
        message: 'Requires policy 15 approval.',
        link: '/policy-edit/015',
        order: 20
    }, {
        flag: 'Policy016Set',
        message: 'Requires policy 16 approval.',
        link: '/policy-edit/016',
        order: 21
    }, {
        flag: 'Policy017Set',
        message: 'Requires policy 17 approval.',
        link: '/policy-edit/017',
        order: 22
    }, {
        flag: 'Policy018Set',
        message: 'Requires policy 18 approval.',
        link: '/policy-edit/018',
        order: 23
    }, {
        flag: 'Policy019Set',
        message: 'Requires policy 19 approval.',
        link: '/policy-edit/019',
        order: 24
    }, {
        flag: 'Policy020Set',
        message: 'Requires policy 20 approval.',
        link: '/policy-edit/020',
        order: 25
    }, {
        flag: 'POSet',
        message: 'Requires a designated privacy officer.',
        link: '/practice/po',
        order: 1
    }, {
        flag: 'RMSet',
        message: 'Requires Risk Management plan to be completed.',
        link: '/risk/start',
        order: 27
    }, {
        flag: 'WorkforceSet',
        message: 'Requires workforce be saved.',
        link: '/workforce-list',
        order: 3
    },
    // Tour flags
    {
        flag: 'TourWelcome',
        message: 'Tour of the dashboard page',
        link: '/',
        order: 0
    }
])

export const progress = {
    namespaced: true,
    state: {
        downloaded: false,
        flags: Enumerable.from(flagMap()).toObject((k) => { return k.flag; }, (v) => { return false; }),
        requiredFlags: []
    },
    getters: {
        missingFlags: (state) => {
            return Enumerable.from(flagMap())
                .join(state.requiredFlags,
                    o => { return o.flag; },
                    i => { return i; },
                    (o, i) => { return {...o } })
                .join(state.flags,
                    o => { return o.flag; },
                    i => { return i.key },
                    (o, i) => { return {...o, set: i.value } })
                .where(x => { return !x.set })
                .orderBy(x => { return x.order })
                .toArray();
        }
    },
    mutations: {
        setDownloaded: (state, downloaded) => {
            state.downloaded = downloaded;
        },
        setFlag: (state, { flag, value }) => {
            state.flags[flag] = value;
        },
        setState: (state, newState) => {
            let defaultFlags = Enumerable.from(flagMap()).toObject((k) => { return k.flag; }, (v) => { return false; });
            state.flags = {...defaultFlags, ...newState };
            // Object.assign(state.flags, {...defaultFlags, ...newState });
        },
        setRequiredFlags: (state, flags) => {
            state.requiredFlags = flags;
        }
    },
    actions: {
        setFlag: ({ commit, state }, { flag, value }) => {
            if (state.flags[flag] === value) {
                console.log('Store[Progress]: Progress [%s] already set =>', flag, value);
                return Promise.resolve(state.flags);
            } else {
                console.log('Store[Progress]: Setting [%s] progress =>', flag, value);
                commit('setFlag', { flag, value });

                return practiceService.setFlags(state)
                    .then(data => {
                        console.log('Store[Progress]: Progress uploaded');
                        return data;
                    }, error => {
                        console.log('Store[Progress]: Progress upload error =>', error);
                    });
            }
        },
        setFlagDone: ({ dispatch }, flag) => {
            return dispatch('setFlag', { flag, value: true });
        },
        setRequiredFlags: ({ commit, state }, flags) => {
            console.log('Store[Progress]: Setting required progress =>', flags);
            commit('setRequiredFlags', flags);
        },
        fetch: ({ commit, state }) => {
            console.log('Store[Progress]: Fetching progress');
            return practiceService.getFlags()
                .then(data => {
                    console.log('Store[Progress]: Progress downloaded =>', data.flags);
                    commit('setState', data.flags);
                    commit('setDownloaded', true);
                    return state.flags;
                }, error => {
                    console.log('Store[Progress]: Progress download error =>', error);
                });
        },
        reset: ({ commit }) => {
            console.log('Store[Progress]: Resetting to defaults');
            commit('setState', {});
            commit('setDownloaded', false);
        }
    }
}